import { render, staticRenderFns } from "./AdminSimpleTable.vue?vue&type=template&id=abf09b66"
import script from "./AdminSimpleTable.vue?vue&type=script&lang=js"
export * from "./AdminSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./AdminSimpleTable.vue?vue&type=style&index=0&id=abf09b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports